var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Chatbot',{attrs:{"is-disabled":_vm.isDisabled,"disabled-message":_vm.disabledMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }